import React from 'react';
import _map from 'lodash/map';
import { connect } from 'react-redux';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { getPaymentList } from 'actions/customers/list';
import styles from './List.css';
import Row from './Row';
import Pagination from '../../../Pagination';

class List extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPaymentId: null,
      sizePerPage: 12,
      selectedPage: 1,
    };
  }

  componentDidMount() {
    if (this.props.enableCustomerServiceDetailLazyLoad) {
      const pagination = {
        page: 1,
        per_page: this.state.sizePerPage,
      };
      this.props.getPaymentList(this.props.customerDetail, pagination);
    }
  }

  render() {
    const {
      payments,
      paymentList,
      enableCustomerServiceDetailLazyLoad,
    } = this.props;

    const showLazyPageContent =
      enableCustomerServiceDetailLazyLoad && paymentList;

    return showLazyPageContent ? (
      <div className={styles['length-wrapper']}>
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.date}>Date</th>
                <th className={styles.outlet}>Outlet</th>
                <th className={styles.sale}>Sale</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <table className={styles['table-content']}>
              <tbody>{this._getPageView()}</tbody>
            </table>
          </div>
        </div>
        <Pagination
          className="pull-right"
          numPages={Math.ceil(paymentList.total_count / this.state.sizePerPage)}
          currentPage={this.state.selectedPage}
          onPageItemClick={this._onSelectPageNumber}
        />
      </div>
    ) : (
      <div className={styles['length-wrapper']}>
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.date}>Date</th>
                <th className={styles.outlet}>Outlet</th>
                <th className={styles.sale}>Sale</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <table className={styles['table-content']}>
              <tbody>{this._getRowsView()}</tbody>
            </table>
          </div>
        </div>
        <Pagination
          className="pull-right"
          numPages={Math.ceil(payments.length / this.state.sizePerPage)}
          currentPage={this.state.selectedPage}
          onPageItemClick={this._onSelectPageNumber}
        />
      </div>
    );
  }

  _getRowsView = () => {
    const { payments } = this.props;
    const { selectedPage, sizePerPage } = this.state;
    const arrayStartingIndex = (selectedPage - 1) * sizePerPage;
    const arrayEndIndex = selectedPage * sizePerPage;
    return _map(payments.slice(arrayStartingIndex, arrayEndIndex), payment => {
      return (
        <Row
          key={payment.id}
          onClickRow={this._onClickRow}
          payment={payment}
          isSelected={
            this.state.selectedPaymentId === payment.parent_payment_id
          }
        />
      );
    });
  };

  _getPageView = () => {
    const { paymentList } = this.props;

    return _map(paymentList.data.slice(0, this.state.sizePerPage), payment => {
      return (
        <Row
          key={payment.id}
          onClickRow={this._onClickRow}
          payment={payment}
          isSelected={
            this.state.selectedPaymentId === payment.parent_payment_id
          }
        />
      );
    });
  };

  _onSelectPageNumber = eventKey => {
    this.props.closeDetail();
    this.setState({ selectedPage: eventKey, selectedPaymentId: '' });

    if (this.props.enableCustomerServiceDetailLazyLoad) {
      const pagination = {
        page: eventKey,
        per_page: this.state.sizePerPage,
      };
      this.props.getPaymentList(this.props.customerDetail, pagination);
    }
  };

  _onClickRow = payment => {
    this.props.openReceipt({
      payment_type: payment.payment_type,
      parent_payment_id: payment.parent_payment_id,
    });
    this.setState({ selectedPaymentId: payment.parent_payment_id });
  };
}

function mapStateToProps(state) {
  const {
    customers: {
      list: { paymentList },
    },
  } = state;

  return { paymentList };
}

const mapFlagsToProps = flags => {
  return {
    enableCustomerServiceDetailLazyLoad:
      flags.enableCustomerServiceDetailLazyLoad,
  };
};

export default withFeatureFlags(mapFlagsToProps)(
  connect(
    mapStateToProps,
    { getPaymentList }
  )(List)
);
